<template>
    <div id="app">
        <vue-picture-viewer ref="pictureViewer" :imgData="[]" :switch="true"></vue-picture-viewer>
        <router-view></router-view>
    </div>
</template>

<script>
import VuePictureViewer from '@/components/PictureViewer/vue-picture-viewer.vue'

export default {
    name: 'App',
    provide(){
        return{
            openPictureViewer: this.openPictureViewer
        }
    },
    components: {
        "vue-picture-viewer": VuePictureViewer
    },
    methods: {
        /**
         * 打开图片预览
         * @param data
         * @param index
         */
        openPictureViewer(data,index) {
          this.$refs.pictureViewer.openViewer(data,index)
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue